import {Pipe, PipeTransform} from '@angular/core';
import dateFormat from 'dateformat';

@Pipe({
    name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {

    transform(
        value: string | Date,
        format: string = 'mmmm dd, yyyy \'at\' h:MM:ss TT Z',
    ): string {
        return dateFormat(value, format);
    }
}
